/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import MachineDiagram from "../../../components/MachineDiagram.js";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, null, "HOW TO USE"), "\n", React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "Push “POWER” to turn on APMA-2000."), "\n", React.createElement(_components.li, null, "Select language."), "\n", React.createElement(_components.li, null, "Drag radio tuner lamp or turn dial to tune in to narratives or music channels."), "\n", React.createElement(_components.li, null, "Listen and reflect / contemplate / meditate on our life on the planet."), "\n", React.createElement(_components.li, null, "Control tracks - Backward, forward, pause, etc."), "\n", React.createElement(_components.li, null, "Cards are printed to help learning. touch them to enlarge."), "\n"), "\n", React.createElement(MachineDiagram));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
